
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/veeam",
      function () {
        return require("private-next-pages/veeam.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/veeam"])
      });
    }
  